/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HouseTypeEnum = 1 | 2;

export const HouseTypeEnum = {
    NUMBER_1: 1 as HouseTypeEnum,
    NUMBER_2: 2 as HouseTypeEnum
};

